var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions flex gap-2" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleAddDevices },
                },
                [_vm._v("\n          Thêm thiết bị\n        ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn blue-btn",
                  attrs: { type: "primary", icon: "el-icon-refresh" },
                  on: { click: _vm.handleCheckStatus },
                },
                [_vm._v("\n          Kiểm tra trạng thái\n        ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn purple-btn",
                  attrs: { type: "warning", icon: "el-icon-share" },
                  on: { click: _vm.registerWebhookManyDevice },
                },
                [_vm._v("\n          Đăng ký Webhook\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng số thiết bị"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalRecords)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đang hoạt động (Online)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.onlineCount)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đã đăng ký Webhook"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.webhookCount)),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataFilter },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả các trường",
                      },
                      on: { change: _vm.searchFindAllDevices },
                      model: {
                        value: _vm.dataFilter.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "idSchool", $$v)
                        },
                        expression: "dataFilter.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả trạng thái",
                      },
                      on: { change: _vm.searchFindAllDevices },
                      model: {
                        value: _vm.dataFilter.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "active", $$v)
                        },
                        expression: "dataFilter.active",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Online", value: true },
                      }),
                      _c("el-option", {
                        attrs: { label: "Offline", value: false },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchFindAllDevices },
                    },
                    [_vm._v("Lọc dữ liệu")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table",
                },
              ],
              ref: "multipleTable",
              staticClass: "modern-table",
              attrs: {
                data: _vm.dataTable,
                "element-loading-text": "Đang lấy dữ liệu thiết bị...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Tên trường", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "school-name-text",
                            on: {
                              click: function ($event) {
                                return _vm.updateDevice(row, true)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.nameSchool))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Tên thiết bị", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "device-name-text" }, [
                          _c("i", {
                            staticClass: "el-icon-s-platform",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "4px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(row.nameDevice) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Hãng", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: "info",
                              effect: "plain",
                            },
                          },
                          [_vm._v(_vm._s(row.typeDevice || "Hik"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thông tin kết nối", "min-width": "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "info-list" }, [
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("Tên miền:"),
                            ]),
                            _c("strong", [
                              _vm._v(_vm._s(row.schoolDomain || "—")),
                            ]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("IP Local:"),
                            ]),
                            _c("strong", [_vm._v(_vm._s(row.ipLocal || "—"))]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("Port Local / HTTP:"),
                            ]),
                            _c("strong", [_vm._v(_vm._s(row.port || "—"))]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thông tin tài khoản", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "info-list" }, [
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("Acc:"),
                            ]),
                            _c("code", [_vm._v(_vm._s(row.adminAcc))]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "info-lbl" }, [
                              _vm._v("Pass:"),
                            ]),
                            _c("code", [_vm._v(_vm._s(row.adminPassword))]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Hoạt động", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: row.active ? "online" : "offline",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.active ? "Online" : "Offline") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Đăng ký Webhook",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.webhookRegister ? "success" : "danger",
                              size: "medium",
                              effect: "light",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.webhookRegister
                                    ? "Đã đăng ký"
                                    : "Chưa đăng ký"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thông tin Modem", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.modemAcc || row.modemPassword
                          ? _c("div", { staticClass: "info-list" }, [
                              _c("div", [
                                _c("span", { staticClass: "info-lbl" }, [
                                  _vm._v("Acc:"),
                                ]),
                                _c("code", [_vm._v(_vm._s(row.modemAcc))]),
                              ]),
                              _c("div", [
                                _c("span", { staticClass: "info-lbl" }, [
                                  _vm._v("Pass:"),
                                ]),
                                _c("code", [_vm._v(_vm._s(row.modemPassword))]),
                              ]),
                            ])
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Version điểm danh",
                  width: "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: "warning",
                              effect: "plain",
                            },
                          },
                          [_vm._v(_vm._s(row.versionAttendance || "VERSION_1"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "310",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "mini",
                              icon: "el-icon-refresh",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openSynchronizeDevices(row)
                              },
                            },
                          },
                          [_vm._v("\n            Đồng bộ\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateDevice(row, false)
                              },
                            },
                          },
                          [_vm._v("\n            Sửa\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDevice(row)
                              },
                            },
                          },
                          [_vm._v("\n            Xóa\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataFilter.page,
                  "page-sizes": _vm.pageListDefaultNewOneAdmin,
                  "page-size": _vm.dataFilter.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalRecords,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("synchronize-devices-dialog", {
        ref: "synchronizeDialog",
        on: { synchronized: _vm.findAllDevices },
      }),
      _c("AddDevice", {
        attrs: { "is-open": _vm.isOpen.add, schoolList: _vm.schoolList },
        on: { closeDialog: _vm.handleCloseDialogAdd },
      }),
      _c("UpdateDevice", {
        attrs: {
          showDetail: _vm.showDetail,
          idDevice: _vm.idDevice,
          "is-open": _vm.isOpen.update,
        },
        on: { closeDialog: _vm.handleCloseDialogUpdate },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-connection" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("QUẢN LÝ THIẾT BỊ NHẬN DIỆN AI"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Quản lý danh sách, cấu hình kết nối, đăng ký Webhook và đồng bộ trạng thái các thiết bị AI."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-monitor" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-link" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }